import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../../shadcn/components/ui/table";

export function JBSecondaryBidderTable({ bidders = [] }) {
  return (
    <div className="mx-auto overflow-x-scroll border border-gray-200 bg-white shadow-sm">
      <Table>
        <TableHeader>
          <TableRow className="">
            <TableHead className="text-gray-700 font-semibold text-xs min-w-14 px-2">
              Sr No.
            </TableHead>
            <TableHead className="text-gray-700 font-semibold text-xs min-w-36 px-2">
              Name
            </TableHead>
            <TableHead className="text-gray-700 font-semibold text-xs min-w-48 px-2">
              Email Id
            </TableHead>
            <TableHead className="text-gray-700 font-semibold text-xs min-w-24 px-2">
              Mobile
            </TableHead>
            <TableHead className="text-gray-700 font-semibold text-xs min-w-24 px-2">
              Access Type
            </TableHead>
            <TableHead className="text-gray-700 font-semibold text-xs min-w-32 px-2">
              Consent Status
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {bidders.length > 0 ? (
            bidders.map((bidder: any, index: any) => (
              <TableRow key={bidder?.bidder_uuid}>
                <TableCell className="text-xs capitalize font-normal font-openSans px-2">
                  {index + 1}.
                </TableCell>
                <TableCell className="text-xs capitalize font-normal font-openSans px-2">
                  {bidder?.meta?.name || "—"}
                </TableCell>
                <TableCell className="text-xs font-normal font-openSans px-2">
                  {bidder?.meta?.email || "—"}
                </TableCell>
                <TableCell className="text-xs font-normal font-openSans px-2">
                  {bidder?.meta?.user_details?.mobile_number || "—"}
                </TableCell>
                <TableCell className="text-xs capitalize font-normal font-openSans px-2">
                  {bidder?.type || "—"}
                </TableCell>
                <TableCell className="text-xs capitalize font-normal font-openSans px-2">
                  <span
                    className={`px-2 py-1 rounded-full text-xs ${
                      bidder.consent_status === "approved"
                        ? "bg-green-100 text-green-700"
                        : bidder.consent_status === "rejected"
                        ? "bg-red-100 text-red-700"
                        : "bg-yellow-100 text-yellow-700"
                    }`}
                  >
                    {bidder.consent_status ? bidder.consent_status : "pending"}
                  </span>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-gray-500">
                No bidders found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
